import { render } from "./FunnelChart.vue?vue&type=template&id=4d5db20d&scoped=true"
import script from "./FunnelChart.vue?vue&type=script&lang=js"
export * from "./FunnelChart.vue?vue&type=script&lang=js"

import "./FunnelChart.vue?vue&type=style&index=0&id=4d5db20d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5db20d"]])

export default __exports__